import HealthCheckService from "@client.services/healthcheckService";
import GoogleService from "@client.services/googleService";
import MicrosoftService from "@client.services/microsoftService";
import NotificationService from "@client.services/notificationService";
import MeetingsService from "@client.services/meetingsService";
import UserService from "@client.services/userService";
import SalaryRangeService from "@client.services/salaryRangeService";
import EventEmitterService from "@client.services/EventEmitter";
import TeamService from "./teamService";
import UserNotificationSettingService from "./userNotificationSettingService";
import AuthService from "./authService";
import CalendarService from "./calendarService";
import LogService from "./logService";

export default class ServiceProvider {
  static HealthCheck = new HealthCheckService();
  static Auth = new AuthService();
  static Google = new GoogleService();
  static Microsoft = new MicrosoftService();
  static Notification = new NotificationService();
  static Meetings = new MeetingsService();
  static User = new UserService();
  static SalaryRange = new SalaryRangeService();
  static Team = new TeamService();
  static EventEmitter = new EventEmitterService();
  static UserNotificationSetting = new UserNotificationSettingService();
  static Calendar = new CalendarService();
  static Log = new LogService();
}
